import script from "./OrganizationExamplesComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationExamplesComponent.vue?vue&type=script&setup=true&lang=js"

import "./OrganizationExamplesComponent.vue?vue&type=style&index=0&id=45104b56&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45104b56"]])

export default __exports__